module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.ddd2e3c7.jpg";